import { useMemo } from "react";
import MessageBar from "./MessageBar";
import NotificationLogListener from "./Notification";
import NonRecoverableErrorModal from "./NonRecoverableErrorModal";
import { useFlags } from "launchdarkly-react-client-sdk";

type TTempLogListenerSelectorProps = {
    messageSize: {
        width: any;
        marginLeft: number;
    };
};

const TempLogListenerSelector = ({ messageSize }: TTempLogListenerSelectorProps) => {
    const ldFlags = useFlags();
    const shouldUseNewLogListener = ldFlags?.coreUseNewNotificationLogListener ?? false;

    const logListener = useMemo(
        () =>
            shouldUseNewLogListener ? (
                <NotificationLogListener />
            ) : (
                <MessageBar style={messageSize} flags={ldFlags} />
            ),
        [shouldUseNewLogListener]
    );

    // Non-recoverable errors are always presented in a modal, regardless of which log listener
    // is active.
    return (
        <>
            {logListener}
            <NonRecoverableErrorModal />
        </>
    );
};

export default TempLogListenerSelector;
